module.exports = __webpack_public_path__ + "static/media/03-2-galeria-04-omega@2x.0c297c00.jpg";